export default {"src":"https://assets.willie.be/003a5d6bcce39278/_next/static/media/burger.97ff941d.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};